import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ExternalLink } from 'lucide-react';

export default function SuggestionsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
            className="rounded-full"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Suggestions</h1>
            <p className="text-gray-500">Help us improve UniConnect</p>
          </div>
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 text-center">
          <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <ExternalLink className="w-8 h-8 text-indigo-600" />
          </div>
          
          <h2 className="text-xl font-semibold text-gray-900 mb-3">
            We'd love to hear from you!
          </h2>
          
          <p className="text-gray-600 mb-8 max-w-md mx-auto">
            Have a feature idea, found a bug, or want to request a new course? 
            Share your thoughts with us through our feedback form.
          </p>

          <a
            href="https://forms.gle/8EY26o5McCvnoFB89"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-xl text-lg">
              Submit a suggestion
              <ExternalLink className="w-5 h-5 ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
